import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";
import {Button, Form, Input, Modal} from "antd";
import swal from "sweetalert";
import { signin, signinByMicrosoft } from "services/auth";
import MicrosoftLogin from "react-microsoft-login";
import styles from "./style";
import "./signin.css";

export default function UserAuthentication() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const userNameInputRef = React.useRef(null);
  const [form] = Form.useForm();

  React.useEffect(() => {
    userNameInputRef.current.focus();
  }, []);

  const handleSubmit = (values) => {
    setLoading(true);
    signin("npa", values["userName"], values["password"])
      .then((response) => {
        if (response) {
          const data = response.data.data;
          localStorage.setItem("ACCESS_TOKEN", JSON.stringify(data));
          localStorage.setItem("PRIVATE_URL", values["privateURL"]);
          navigate("/");
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        if (err && err.response && err.response.data) {
          const { error } = err.response.data;
          swal({
            title: error.message,
            icon: "error",
            timer: 2000,
            buttons: false,
          }).then(() => {
            setLoading(false);
          });
        }
      });
  };

  const microsoftLoginHandler = (err, data) => {
    const datas = localStorage.getItem(localStorage.key(0))

    if (datas) {
      const account = JSON.parse(datas);
      signinByMicrosoft(account.idTokenClaims.email, account.idTokenClaims.name)
      .then((response) => {
        if (response) {
          const data = response.data.data;
          localStorage.setItem("ACCESS_TOKEN", JSON.stringify(data));
          localStorage.setItem("PRIVATE_URL", "npa");
          navigate("/dashboard");
          setLoading(false);
        }
      }).catch((err) => {
        setLoading(false);
        if (err && err.response && err.response.data) {
          const { error } = err.response.data;
          swal({
            title: error.message,
            icon: "error",
            timer: 2000,
            buttons: false,
          }).then(() => {
            setLoading(false);
          });
        }
      });;
    }
  }

  return (
    <div style={styles.signin} className="signin">
      <div style={styles.topBgSignin} className="topBgSignin">
        <div className="topBg">
          <div style={styles.logoSignin}>
            <img
              style={{ width: "80px", height: "80px", objectFit: "cover" }}
              src="/logo.png"
              alt="Logo"
            />
          </div>
          <h2 style={styles.title}>Norwegian People's Aid</h2>
          <h2 style={styles.title}>Cambodia</h2>
          <h5 style={styles.subTitle}>{t("text_version")}</h5>
        </div>

        <Form form={form} onFinish={handleSubmit} layout="vertical" className="siginForm">
          <Form.Item
              name="userName"
              rules={[
                {
                  required: true,
                  message: t("text_username_is_required"),
                },
              ]}
              label={t("text_username")}
          >
            <Input
                ref={userNameInputRef}
                placeholder={t("text_please_enter_your_username")}
                style={styles.input}
            />
          </Form.Item>
          <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: t("text_password_is_required"),
                },
              ]}
              label={t("text_password")}
          >
            <Input.Password
                placeholder={t("text_password")}
                style={styles.input}
            />

          </Form.Item>

          <div style={{marginTop: '8px'}}>
            <Button
                type="link"
                style={{padding: 0, fontSize: '14px'}}
                onClick={() => {
                  navigate('/forgot-password');
                }}
            >
              Forgot Password?
            </Button>
          </div>
          <Form.Item className="btn">
            <Button
                loading={loading}
                style={styles.btnSignin}
                type="primary"
                htmlType="submit"
            >
              {t("text_log_in")}
            </Button>
          </Form.Item>
          <MicrosoftLogin
              clientId="e8074f78-883b-4bfc-9a85-24a14785ec06"
              authCallback={microsoftLoginHandler}
              graphScopes={[
                'User.Read',
                'email',
                'profile'
              ]}
              useLocalStorageCache={true}
              redirectUri={'https://khm-hris.npaid.org/signin'}
              withUserData={true}
          />
        </Form>
      </div>

      <div style={styles.fotterSignin}>
        <span>{t("text_ca_invention_copyright")}</span>
      </div>
    </div>
  );
}
